import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';

import {
  CalendarDay,
  CalendarMonth,
  NoDeadline,
  TimeClock,
} from '@brand/icons';

export const jobDateStep: ServiceRequestStep = {
  type: ServiceRequestStepType.DETAILS,
  inSummary: true,
  title: `quote:jobDate.title`,
  segmentEvent: `Time of Execution Selected`,
  fields: [
    {
      type: ServiceRequestFieldType.TILES,
      summaryTitle: `quote:jobDate.summaryTitle`,
      props: {
        name: `job_date`,
        options: [
          {
            label: `quote:jobDate.options.asap`,
            value: `within_2_weeks`,
            icon: <TimeClock />,
          },
          {
            label: `quote:jobDate.options.nextFewWeeks`,
            value: `this_month`,
            icon: <CalendarDay />,
          },
          {
            label: `quote:jobDate.options.nextFewMonths`,
            value: `within_2_months`,
            icon: <CalendarMonth />,
          },
          {
            label: `quote:jobDate.options.flexible`,
            value: `flexible`,
            icon: <NoDeadline />,
          },
        ],
        validation: [`isRequired`],
      },
    },
  ],
};
